import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';


import fondo from '../../assets/img/landingPage/fondo.png';
import dashboard from '../../assets/img/landingPage/modeling/dashboar_APIDesign01.png';

import icon_free from '../../assets/img/landingPage/aws/icn-aws.png'
import icon_dyn from '../../assets/img/landingPage/flow/icn_Flow-01.png'
import icon_expo from '../../assets/img/landingPage/composable/icn_composable_04.png'

import features_1 from '../../assets/img/landingPage/aws/aws.png'
import features_2 from '../../assets/img/landingPage/aws/aws2.png'
import features_3 from '../../assets/img/landingPage/publisher/Publisher_03.png'
import features_4 from '../../assets/img/landingPage/meshManager/MeshManager-02.png'

import logo from '../../assets/img/logos/AVAP-Cloud-AWS.svg'
import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'




import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

const CloudAWSProduct = () => {
    
  useEffect(() => {
    // favicon 
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = Favicon; // Usa la ruta importada directamente
    document.head.appendChild(link);

    // clean favicon 
    return () => {
      document.head.removeChild(link);
    };
  }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}>
                
                {/* Hero Section */}
                <section id="heroProduct" className="text-center pt-5 ">
                    <img
                        src={logo}
                        alt="Logo AVAP Cloud AWS Edition"
                        className="img-fluid logoAWS"
                    />
                    <h1 className="fl-title m-0 ">Enterprise-grade API Management. Deployed <br /> in Minutes from AWS.</h1>
                    <p className="fl-subtitle">
                        Full power, zero friction. Launch AVAP Cloud directly from AWS Marketplace.
                    </p>
                   {/* <a className="glowBtn-dark fakeHide" href="#"><span className="btnInner">  Start with AVAP Cloud</span></a>*/}
                   
                </section>

                {/* Powerful API Platform */}
                <section id='subtitleSection' className="text-center pb-5">
                    <div className="row">
                        <div className="col">    
                            {/* <p className="fl-subtitle mb-3">
                                Titulo
                            </p> */}
                            {/*<img
                            src={dashboard}
                            alt=" Modern API Design with OAS and A2ML (AVAP API Modeling Language) 
                            for Scalable Architecture"
                            className="img-fluid mt-4"
                            style={{ 
                            width: '90%', 
                            maxWidth: '900px', 
                            height: 'auto' ,
                            paddingTop: "100px" }}
                            /> */} 
                            <p className="fl-subtitle mb-3 fl-txt-container-s">
                            AVAP Cloud AWS Edition. Scalable, secure API management deployed in minutes from AWS.
                            </p>
                            <p className="fl-text fl-txt-container-s">
                            AVAP Cloud AWS Edition offers the fastest, most seamless way to unlock the full power of AVAP’s enterprise-grade API management directly from AWS. Built for organizations accelerating their digital transformation, this specialized edition delivers a fully managed environment to build, orchestrate, and automate APIs and microservices at scale. With simplified AWS billing, built-in compliance, and zero infrastructure hassle, AVAP Cloud AWS Edition empowers teams to move faster, innovate freely, and scale confidently.
                            </p>
                        </div>
                    </div>

                </section>

                {/* Features */}
                <section className="container pb-5">
                    <div className="row">
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_free} alt="Icon of a magnifying glass representing API observability." />
                                <p>AWS-Native Deployment</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_dyn} alt="Icon of a graph with AI elements symbolizing data analytics." />
                                <p>Fully Managed API Infrastructure</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_expo} alt="Icon of a clock symbolizing real-time insights" />
                                <p>Enterprise-Ready Architecture</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Key Featuring */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center">
                            <img
                                src={features_1}
                                alt="Illustration of interactive API dashboards displaying data and performance metrics."
                                className="img-fluid"
                                style={{ width: '80%', maxWidth: '900px', height: 'auto' }}
                            />
                        </div>
                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Instant Deployment via AWS Marketplace</h3>
                            <p className="fl-text">
                                Get up and running in minutes with a pre-approved, one-click deployment directly from AWS Marketplace, no contracts, no waiting.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Key Featuring */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 pl-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Integrated Billing and Enterprise Compliance</h3>
                            <p className="fl-text">
                                Consolidate your procurement process with native AWS billing while meeting strict enterprise security and compliance requirements.
                            </p>
                        </div>

                        <div className="col-md-6 text-center">
                            <img
                                src={features_2}
                                alt="Illustration of AVAP Vision icon monitoring systems to detect anomalies."
                                className="img-fluid"
                                style={{ width: '80%', maxWidth: '900px', height: 'auto' }}
                            />
                        </div>
                    </div>
                </section>

                {/* Key Featuring */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center">
                            <img
                                src={features_3}
                                alt="Illustration of AVAP Vision overseeing AVAP Framework, monitoring performance and ensuring optimization."
                                className="img-fluid"
                                style={{ width: '80%', maxWidth: '900px', height: 'auto' }}
                            />
                        </div>


                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Scalable, High-Performance Infrastructure</h3>
                            <p className="fl-text">
                                Automatically adjust capacity to meet demand with zero downtime. Focus on your APIs while AVAP Cloud manages the infrastructure behind the scenes.
                            </p>
                        </div>

                    </div>
                </section>

                 {/* Key Featuring */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center">
                            <img
                                src={features_4}
                                alt="Illustration of AVAP Vision overseeing AVAP Framework, monitoring performance and ensuring optimization."
                                className="img-fluid"
                                style={{ width: '80%', maxWidth: '900px', height: 'auto' }}
                            />
                        </div>


                        <div className="col-md-6 pl-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Fully Managed Platform with Expert Support</h3>
                            <p className="fl-text">
                                Benefit from continuous updates, proactive monitoring, and dedicated technical support, ensuring your API operations stay secure, current, and optimized.
                            </p>
                        </div>

                    </div>
                </section>
                
                {/* Key Featuring */}
                <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col mb-5 pb-2 pt-4">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                    Accelerate Time to Value
                                </p>
                                <p className="fl-text">
                                    Deploy in minutes and start building immediately, with no setup delays, no infrastructure complexity.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs"> 
                                    Simplify Procurement and Compliance
                                </p>
                                <p className="fl-text">
                                    Leverage your existing AWS financial and security frameworks with native billing and built-in enterprise-grade compliance.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                   Empower Development Without DevOps Overhead
                                </p>
                                <p className="fl-text">
                                    Give your teams a scalable, fully managed API platform that streamlines development, orchestration, and deployment, so they can focus on innovation, not infrastructure.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Getting Started */}
                <div className="bottomWrapper position-relative d-flex justify-content-center">
                    <img src={gradientbottom} alt="" className="gradient gradientBottom" />
                </div>
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default CloudAWSProduct;
